import { memo } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { TableBody } from '@mui/material';

import { ActionInterface, ColumnInterface, GenericObject } from '@app/components/common/Table/DefaultTable/types';

import { DefaultTableRow } from './DefaultTableRow';

export interface DefaultTableBodyProps {
  columns: ColumnInterface[];
  rows: GenericObject[] | undefined;
  rowKey: string;
  resource?: string;
  orderable?: boolean;
  actions: ActionInterface[];
  reorderRecord?(dragIndex: number, hoverIndex: number): void;
  isRowEditable?: Function;
}

export const DefaultTableBody = memo(
  ({
    reorderRecord,
    columns,
    rows,
    rowKey,
    resource,
    orderable = false,
    actions,
    isRowEditable,
  }: DefaultTableBodyProps) => {
    return (
      <DndProvider backend={HTML5Backend}>
        <TableBody>
          {rows &&
            rows.map((row: GenericObject, index: number) => {
              let actionsToPassToRow = actions;
              if (isRowEditable !== undefined && !isRowEditable(row)) {
                actionsToPassToRow = [];
              }
              return (
                <DefaultTableRow
                  resource={resource}
                  key={row[rowKey] as number}
                  reorderRecord={reorderRecord}
                  orderable={orderable}
                  rows={rows}
                  row={row}
                  columns={columns}
                  actions={actionsToPassToRow}
                  index={index}
                  rowKey={rowKey}
                />
              );
            })}
        </TableBody>
      </DndProvider>
    );
  }
);
